export default class MicroflowDataSource {
  constructor(Vue, id, data) {
    this._id = id
    this.$store = Vue.$store
    this.$router = Vue.$router
    this.$route = Vue.$route
  
    if (!this.$store) {
      return
    }

    /*---- СОЗДАНИЕ STORE ДЛЯ ДАННЫХ ----*/
    
    // если модуль зарегистрирован, значит нужно обновить его данные
    // этот сценарий проявляется в случае перехода на страницу, на которой уже были, и данные нужно перечитать.
    if (this.$store.state[this.getStoreModuleName()] !== undefined) {
      this.$store.commit(`${this.getStoreModuleName()}/setData`, data)
      return
    }
    // формирование модуля vuex
    let storeModule = {
      namespaced: true,
      state: {
        data: data
      },
      mutations: {
        setData(state, data) {
          state.data = data
        }
      }
    }
    this.$store.registerModule(this.getStoreModuleName(), storeModule)

    /*--- СОЗДАНИЕ STORE ДЛЯ ФИЛЬТРОВ ----*/

    // формирование модуля vuex для фильтров
    let filtersStoreModule = {
      namespaced: true,
      state: {
        data: data
      },
      mutations: {
        setData(state, data) {
          state.data = data
        }
      }
    }
    this.$store.registerModule(this.getFiltersModuleName(), filtersStoreModule)
  }
  
  getData() {
    return this.$store.state[this.getStoreModuleName()].data
  }

  setFilters(data) {
    this.$store.commit(`${this.getFiltersModuleName()}/setData`, data)
  }

  getFilters() {
    return this.$store.state[this.getFiltersModuleName()].data
  }
  
  /** Формирование имени для vuex модуля  */
  getStoreModuleName() {
    return `microflow_datasource_${this._id}`
  }

  /** Формирование имени для vuex модуля фильтров */
  getFiltersModuleName() {
    return `objectModel_datasource_filters${this._id}`
  }

  refresh() {}
}